import {ReactComponent as BarcodeIcon} from './barcode.svg'

function Barcode() {
  return <BarcodeIcon />
}

export default Barcode
